import { apply as jsonLogicApply } from 'json-logic-js';
import { formatQuery } from "react-querybuilder";
import { groupBy } from "../../utils/arrayUtilities";
import { dynamicSort } from "../../utils/tableUtilities";

export const buildData = (data, filter, grouping, collation, sort, mapping) => {
    if (data && Array.isArray(data)) {
        data = [...data]
        if (filter?.rules?.length > 0) {
            const jsonLogicFilter = formatQuery(filter, 'jsonlogic')
            data = data?.filter(entry => jsonLogicApply(jsonLogicFilter, entry));
        }
        if (grouping) {
            data = Object.entries(groupBy(data, grouping)).map(([x, y]) => ({ x, y: y.length }));
        }
        switch (collation?.mode) {
            case 'topN': {
                data.sort(dynamicSort(['-y']));
                const other = data.slice(collation.n).reduce((prev, cur) => prev + cur.y, 0);
                data = data.slice(0, collation.n);
                if (other > 0) {
                    data.push({ x: collation.other, y: other });
                }
                break;
            }
            case 'group':
                data = collation.groups.map(g => {
                    let groupData = null;
                    if (g.min !== undefined && g.max !== undefined) {
                        groupData = data.filter(value => value.x >= g.min && value.x < g.max).map(value => value.y ?? 0).reduce((prev, cur) => prev + cur, 0);
                    } else if (g.values) {
                        groupData = data.filter(value => g.values.some(v => v === value.x)).map(value => value.y ?? 0).reduceRight((prev, cur) => prev + cur, 0);
                    }
                    return {
                        x: g.label,
                        y: groupData
                    }
                });
                break;
            case 'count':
                data = [{ x: 'Count', y: data.reduce((sum, cur) => sum + cur.y, 0) }]
                break;
            case 'mean':
                data = [{ x: 'Mean', y: data.reduce((sum, cur) => sum + cur.y, 0) / data.length }];
                break;
            case 'median': {
                data.sort();
                const mid = Math.floor(data.length / 2);
                let median;
                if (data.length % 2 === 0) {
                    // If even, average of two middle numbers
                    median = (data[mid - 1].y + data[mid].y) / 2;
                } else {
                    // If odd, middle number
                    median = data[mid].y;
                }
                data = [{ x: 'Median', y: median }];
                break;
            }
            case 'mode': {
                const frequencyMap = data.reduce((acc, val) => {
                    acc[val.x] = (acc[val.x] || 0) + val.y;
                    return acc;
                }, {});
                const maxFrequency = Math.max(...Object.values(frequencyMap));
                const mode = Object.keys(frequencyMap).filter(key => frequencyMap[key] === maxFrequency).map(Number);
                data = mode.map(m => ({ x: 'Mode', y: m }));
                break;
            }
            case 'none':
            default:
                break;
        }
        if (mapping) {
            data = data.map(({ x, y }) => ({ x: mapping[x] ?? x, y }));
        }
        if (sort) {
            data.sort(dynamicSort([sort]));
        }
    }
    return data;
}